// src/components/Contact.js
import React, { useState } from 'react';

const Contact = ({ language }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form submitted:', formData);
    alert(language === 'ar' ? 'تم إرسال رسالتك بنجاح!' : 'Your message has been sent successfully!');
    setFormData({ name: '', email: '', subject: '', message: '' });
  };

  const contactInfo = [
    {
      icon: "📍",
      title: { en: "Address", ar: "العنوان" },
      content: { 
        en: "10th of Ramadan - Arma Factories", 
        ar: "العاشر من رمضان - مصانع ارما" 
      }
    },
    {
      icon: "📞",
      title: { en: "Phone", ar: "الهاتف" },
      content: { 
        en: "Mohamed Esmail (Training Manager) : 01002222693 \n Abdelmoneim Ismail (Senior Training Supervisor) : 01128511183", 
        ar: "محمد اسماعيل (مدير التدريب) : ٠١٠٠٢٢٢٢٦٩٣ \n عبدالمنعم اسماعيل (مشرف اول تدريب) : ٠١١٢٨٥١١١٨٣" 
      }
    },
    {
      icon: "✉️",
      title: { en: "Email", ar: "البريد الإلكتروني" },
      content: { 
        en: "arma.academy@armagroupeg.com", 
        ar: "arma.academy@armagroupeg.com" 
      }
    },
    {
      icon: "🕒",
      title: { en: "Working Hours", ar: "ساعات العمل" },
      content: { 
        en: "Sun - Thu: 9:00 AM - 5:00 PM", 
        ar: "الأحد - الخميس: ٩:٠٠ ص - ٥:٠٠ م" 
      }
    }
  ];

  return (
    <section id="contact" className="py-16 bg-green-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-green-900 mb-4">
            {language === 'ar' ? 'اتصل بنا' : 'Contact Us'}
          </h2>
          <div className="w-24 h-1 bg-green-600 mx-auto"></div>
          <p className="text-gray-600 max-w-2xl mx-auto mt-4">
            {language === 'ar' 
              ? 'نحن هنا للإجابة على استفساراتكم وتلقي ملاحظاتكم او مقترحاتكم'
              : 'We are here to answer your inquiries and receive your feedback'}
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
          {/* Contact Information */}
          <div>
            <h3 className="text-2xl font-bold text-green-900 mb-6">
              {language === 'ar' ? 'معلومات التواصل' : 'Contact Information'}
            </h3>
            
            <div className="space-y-6 mb-8">
              {contactInfo.map((info, index) => (
                <div key={index} className="flex items-start">
                  <div className="text-2xl mr-4 rtl:mr-0 rtl:ml-4 mt-1">{info.icon}</div>
                  <div>
                    <h4 className="font-bold text-green-800 text-lg mb-1">
                      {info.title[language]}
                    </h4>
                    <p className="text-gray-700 whitespace-pre-line">
                      {info.content[language]}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* Map Placeholder */}
            {/* <div className="bg-green-200 rounded-xl h-64 flex items-center justify-center">
              <div className="text-center text-green-800">
                <svg className="w-12 h-12 mx-auto mb-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                </svg>
                <p>{language === 'ar' ? 'خريطة الموقع' : 'Location Map'}</p>
              </div>
            </div> */}
          </div>

          {/* Contact Form */}
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-green-900 mb-6">
              {language === 'ar' ? 'أرسل رسالة' : 'Send us a Message'}
            </h3>
            
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                    {language === 'ar' ? 'الاسم الكامل' : 'Full Name'}
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
                  />
                </div>
                
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                    {language === 'ar' ? 'البريد الإلكتروني' : 'Email Address'}
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-2">
                  {language === 'ar' ? 'الموضوع' : 'Subject'}
                </label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
                />
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                  {language === 'ar' ? 'الرسالة' : 'Message'}
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent resize-none"
                ></textarea>
              </div>

              <button
                type="submit"
                className="w-full bg-green-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-green-700 transition-colors transform hover:-translate-y-1 shadow-lg"
              >
                {language === 'ar' ? 'إرسال الرسالة' : 'Send Message'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;